
import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthService from "../services/auth.service";
import { Onboarding2 } from "./common/Icon";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [successful, setSuccessful] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setSuccessful(false);

    try {
      await AuthService.forgotPassword(email); // Assure-toi que cette méthode existe côté service
      setMessage("Un lien de réinitialisation a été envoyé à votre adresse email.");
      setSuccessful(true);
    } catch (error) {
      const resMessage =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();

      setMessage(resMessage);
      setSuccessful(false);
    }
  };

  return (
    <div style={{ position: 'absolute', top: '0', left: '0', backgroundColor: 'white', minHeight: '100vh', width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div className="col-12 col-lg-6 mx-auto" style={{ padding: '20px', maxWidth: "992px" }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img
            src={process.env.PUBLIC_URL + 'icons/Logo_dcare.svg'}
            alt="Logo de DCARE"
            style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', width: "200px" }}
          />
        </div>
        <br />
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div className="mt-3" style={{ maxWidth: '384px' }}>
            <div role="form" aria-labelledby="renew-password-form-title">
              <h1 id="renew-password-form-title" className="text-left mb-1" style={{ fontSize: '1.25em', fontWeight: '700' }}>Mot de passe oublié</h1>
              <p style={{ fontSize: '1em', fontWeight: '400' }}>
                Renseignez votre adresse email pour recevoir un lien de réinitialisation.
              </p>

              {message && (
                <div className="form-group" style={{ marginTop: "20px" }}>
                  <div
                    role="alert"
                    aria-live="assertive"
                    style={{
                      backgroundColor: successful ? "#e2f3e8" : "#fdecea",
                      color: successful ? "#1e4620" : "#611a15",
                      border: `none`,
                      borderRadius: "8px",
                      padding: "16px 20px",
                      fontSize: "1rem",
                      lineHeight: "1.5",
                      textAlign: "center",
                    }}
                    dangerouslySetInnerHTML={{ __html: message }}
                  />
                  {successful && (
                    <div style={{ marginTop: "15px", textAlign: "center" }}>
                      <Link to="/login" style={{ color: "#4fb573", textDecoration: "none", fontWeight: "500" }}>
                        Retourner à la connexion
                      </Link>
                    </div>
                  )}
                </div>
              )}

              {!successful && (
                <div className="mt-4">
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      id="email"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Entrez votre email"
                      aria-required="true"
                      aria-describedby="email-help"
                      style={{fontStyle: 'italic'}}
                    />
                  </div>

                  <div className="mt-4 form-group">
                    <button
                      className="btn-primary btn-block"
                      onClick={handleSubmit}
                      aria-label="Envoyer lien de réinitialisation"
                      style={{ width: '100%' }}
                    >
                      Envoyer le lien
                    </button>
                    <div className="mt-2 text-center">
                      <span style={{ fontSize: '0.875rem' }}>Vous avez retrouvé votre mot de passe ? </span>
                      <Link to={"/login"} className='text-medium' style={{ color: 'var(--color-green)', textDecoration: 'none', paddingRight: '10px' }}>Se connecter</Link>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-6 d-none d-lg-block h-100" style={{ overflow: 'hidden' }}>
        <Onboarding2
          style={{
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            clipPath: "polygon(10% 0%, 100% 0, 100% 100%, 0% 100%)"
          }}
        />
      </div>
    </div>
  );
};

export default ForgotPassword;
